import { useEffect, useState } from "react";

const query = (mq) => (typeof window === "undefined" ? false : window.matchMedia(mq).matches);

/** Phone (<768px) and compact (<1024px, i.e. phone + tablet) breakpoints. */
export function useIsMobile() {
  const [state, setState] = useState(() => ({
    isMobile: query("(max-width: 767px)"),
    isCompact: query("(max-width: 1023px)"),
  }));

  useEffect(() => {
    const phone = window.matchMedia("(max-width: 767px)");
    const compact = window.matchMedia("(max-width: 1023px)");
    const sync = () => setState({ isMobile: phone.matches, isCompact: compact.matches });
    phone.addEventListener("change", sync);
    compact.addEventListener("change", sync);
    return () => {
      phone.removeEventListener("change", sync);
      compact.removeEventListener("change", sync);
    };
  }, []);

  return state;
}
